module.exports = __webpack_public_path__ + "static/media/add exclusion.1c19750e.svg";